import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../../data/content";
import { SectionCta } from "../SectionCta";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-124" data-mp="1223hh69aexzq">
      <div className="mx-auto max-w-2xl" data-id="element-125" data-mp="124ppt8405hj0">
        <h2 className="text-center font-serif text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-126" data-mp="1pro5i3kaslfv">
          Frequently asked <em className="text-brand" data-id="element-127" data-mp="1upzc85faqftv">questions</em>
        </h2>

        <ul className="mt-10 divide-y divide-slate-200 border-y border-slate-200" data-id="element-128" data-mp="1g2nz3z3gunrn">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} data-id="element-129" data-mp="1kz4pz121vg8f" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 py-5 text-left" data-id="element-130" data-mp="28qjyjbkf6ts4">
                  <span className="text-[17px] font-bold leading-snug text-ink" data-id="element-131" data-mp="2onw2hnyb6yo3">{f.q}</span>
                  <PlusIcon className={`mt-0.5 h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-132" data-mp="2jpb31qqvsj0p" />
                </button>
                <AnimatePresence initial={false} data-id="element-133" data-mp="37foy7q4rixzi">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-134" data-mp="32i5be1u01cvy">
                      <p className="pb-5 text-[16px] leading-relaxed text-muted" data-id="element-135" data-mp="1n2pz7b6va5sq">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <SectionCta label="I'm ready — give me access now" data-id="element-136" data-mp="2bqzmtnfxptuu" />
      </div>
    </section>;
}